<template>
  <div>
    <div class="d-flex align-center mb-6">
      <h1 class="text-2xl mr-2">Rentabilité des articles</h1>

      <!-- Bouton info-bulle -->
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="dialog = true"
          >
            <v-icon>{{ icons.mdiInformation }}</v-icon>
          </v-btn>
        </template>
        <span>Ouvre la documentation</span>
      </v-tooltip>
    </div>

    <v-row class="ma-3 justify-center">
      <div class="d-flex align-center">
        <v-btn-toggle v-model="isExternal" mandatory class="mb-4">
          <v-btn :value="false" depressed :color="!isExternal ? 'primary' : ''"
            >Internes</v-btn
          >
          <v-btn :value="true" depressed :color="isExternal ? 'primary' : ''"
            >Externes</v-btn
          >
        </v-btn-toggle>
      </div>
    </v-row>

    <div v-if="isExternal">
      <filters :loading="isLoading"></filters>
      <top-stats-card :loading="isLoading" class="mb-3" />
      <all-posts-table class="mb-3" />
      <grouped-posts-table
        group_by="redac_id"
        class="mb-3"
      ></grouped-posts-table>
      <grouped-posts-table
        group_by="site_id"
        class="mb-3"
      ></grouped-posts-table>
    </div>
    <div v-else>
      <intern-filters></intern-filters>
      <intern-table class="mb-3" />
      <intern-grouped-table
        group_by="redac_id"
        class="mb-3"
      ></intern-grouped-table>
      <intern-grouped-table
        group_by="site_id"
        class="mb-3"
      ></intern-grouped-table>
    </div>
    <DocDialog v-model="dialog" />
  </div>
</template>
<script>
import DocDialog from "@/components/audience/renta-par-article/cards/DocDialog.vue";
import filters from "@/components/audience/renta-par-article/filters/Filters.vue";
import topStatsCard from "@/components/audience/renta-par-article/cards/TopStatsCard";
import allPostsTable from "@/components/audience/renta-par-article/tables/allPostsTable.vue";
import groupedPostsTable from "@/components/audience/renta-par-article/tables/groupedPostsTable.vue";
import internTable from "@/components/audience/renta-par-article/tables/internTable.vue";
import internGroupedTable from "@/components/audience/renta-par-article/tables/internGroupedTable.vue";
import internFilters from "@/components/audience/renta-par-article/filters/InternFilters.vue";
import useAxios from "@/hooks/useAxios";
import { saveRmraView } from "@/utils/rmr-analytics";
import { mdiInformation } from "@mdi/js";

export default {
  name: "RentaParArticles",
  components: {
    DocDialog,
    filters,
    internFilters,
    internTable,
    topStatsCard,
    allPostsTable,
    groupedPostsTable,
    internGroupedTable,
  },
  data() {
    return {
      isExternal: true,
      dialog: false,
      icons: { mdiInformation },
    };
  },
  setup() {
    const { isLoading } = useAxios();

    return {
      isLoading,
    };
  },
  mounted() {
    saveRmraView(this.$route);
  },
  methods: {},
  computed: {},
  watch: {},
};
</script>

<style scoped></style>
